<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:31:25
-->
<template>
  <div>
    <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText
                :label="$t('label_groupName') + '*'"
                :errorMessages="
                  $errors('list', 'group_name', requiredRule.concat(nocharacter))
                "
                :isNational="judegNational('group_name')"
                v-model="list.group_name"
                :readonly="disabled"
              ></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_NumInput
                v-model="list.sort"
                :label="$t('label_The_sorting')"
                :error-messages="$errors('list', 'sort', between('000-999'))"
                :readonly="disabled"
              ></mrc_ess_NumInput>
            </v-col>
            <v-col cols="12">
              <mrc_ess_autoComplete
                :label="$t('label_Use_the_unit') + '*'"
                :readonly="disabled"
                :disabled="true"
                orgView
                :errorMessages="$errors('list', 'company_uuid', requiredRule)"
                v-model="list.company_uuid"
                :prompt_name="org_uuid"
              ></mrc_ess_autoComplete>
            </v-col>
            <v-col cols="12">
              <div style="color: rgba(0, 0, 0, 0.38); font-size: 20px" class="mb-4 mt-10">
                {{ $t("label_groupMember") }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-card class="mb-8" flat outlined rounded="lg">
                <v-card-text>
                  <v-col cols="12">
                    <!-- defaultRequest -->
                    <!-- <mrc_ess_staffInfo :dropDownList='dropDownList'
                                       v-model="list.staffsUuids"
                                       :multiple="true"
                                       org_level_name='f1'
                                       dept_name='f2'
                                       job_post_name='f3'
                                       job_grade_name='f4'
                                       itemText='view_fields'
                                       itemValue='value_field'
                                       :readonly="disabled"
                                       @changeStaffList="changeStaff"
                                       :label="this.$t('label_employee')">
                    </mrc_ess_staffInfo> -->
                    <mrc_ess_staffInfo
                      defaultRequest
                      filter="1,2,3,5"
                      v-model="list.staffsUuids"
                      :multiple="true"
                      :readonly="disabled"
                      @changeStaffList="changeStaff"
                      :label="this.$t('label_employee')"
                    ></mrc_ess_staffInfo>
                  </v-col>
                  <v-col cols="12">
                    <!-- :errMsg="$errors('list','levelsUuids',requiredRule)" -->
                    <mrc_ess_autoComplete
                      :label="$t('label_department')"
                      :readonly="disabled"
                      multiple
                      deptView
                      @changeStaffList="changeDepartment"
                      v-model="list.levelsUuids"
                      :prompt_name="dept_uuid"
                    ></mrc_ess_autoComplete>
                  </v-col>
                  <v-col cols="12">
                    <!-- :errMsg="$errors('list','postsUuids',requiredRule)" -->
                    <mrc_ess_autoComplete
                      :label="$t('label_post')"
                      :readonly="disabled"
                      multiple
                      positionView
                      @changeStaffList="changePosition"
                      v-model="list.postsUuids"
                      :prompt_name="job_post_uuid"
                    ></mrc_ess_autoComplete>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn
          @success="success"
          @cancel="cancel"
          :loading="btnIsLoading"
          v-if="!disabled"
        ></mrc_ess_submitBtn>
      </v-card>
    </mrc_ess_skeleton_loader>
  </div>
</template>

<script>
import {
  getStaffCompanyGroupList,
  addCompanyGroup,
  detailCompanyGroup,
  deleteCompanyGroup,
} from "@/service/api/staffmsg.js";
import { getBusinessList } from "@/service/api/prompt.js";
import { required, maxLength, between, email, url } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      number: 0,
      list: {
        company_uuid: this.$store.state.currentCompany,
      },
      btnIsLoading: false,
      changeStaffList: [],
      changePositionList: [],
      departmentList: [],
      dropDownList: [],
    };
  },
  computed: {
    dept_uuid() {
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
    job_post_uuid() {
      //岗位查询
      return {
        // 2026-08-20  取消岗位根据部门查询
        prompt_name: "job_post_select",
        //   prompt_name: "job_post",
        // org_level_uuid: this.$store.state.currentCompany,
      };
    },
    org_uuid() {
      return {
        prompt_name: "manager-sub-company",
        org_level_uuid: this.$store.state.currentCompany,
      };
      // return { prompt_name: 'org_levels_manager_filter_company', user_uuid: this.$store.state.userData.uuid }
    },
  },
  created() {},
  watch: {},
  async mounted() {
    // getBusinessList({ prompt_name: 'select_personnel', org_level_uuid: this.$store.state.currentCompany }).then(res => {
    //   if (res.code == 200) {
    //     this.dropDownList = res.data
    //   }
    // })
    this.national("mrbase_sys_group");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
  },

  methods: {
    changeStaff(v) {
      this.changeStaffList = v;
    },
    changePosition(v) {
      this.changePositionList = v;
    },
    changeDepartment(v) {
      this.departmentList = v;
    },
    paramsChange() {},
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailCompanyGroup({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      let changeStaffList = [],
        changePositionList = [],
        departmentList = [];
      // console.log(this.list.staffsUuids, this.list.levelsUuids, this.list.postsUuids);
      if (this.list.staffsUuids) {
        changeStaffList = this.list.staffsUuids.split(",").map((item) => {
          return { organization_uuids: item, organization_types: 1 };
        });
      }
      if (this.list.levelsUuids) {
        changePositionList = this.list.levelsUuids.split(",").map((item) => {
          return { organization_uuids: item, organization_types: 2 };
        });
      }
      if (this.list.postsUuids) {
        departmentList = this.list.postsUuids.split(",").map((item) => {
          return { organization_uuids: item, organization_types: 3 };
        });
      }
      // console.log(changeStaffList,
      //   changePositionList,
      //   departmentList);
      // return
      let list = {
        ...this.list,
        group_name: this.list.group_name,
        group_type: 5,
        sort: this.list.sort,
        company_uuid: this.list.company_uuid,
        mrbase_sys_group_sub: [
          ...changeStaffList,
          ...changePositionList,
          ...departmentList,
        ],
      };
      this.btnIsLoading = true;
      if (this.$store.state.uuid) {
        addCompanyGroup({
          ...this.$deletefield(null, list),
          uuid: this.$store.state.uuid,
        }).then(async (res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            await this.getDetail();
            this.$emit("changeReadonly");
          }
          this.btnIsLoading = false;
        });
      } else {
        addCompanyGroup({ ...list }).then(async (res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "staffGroup" });
          }
          this.btnIsLoading = false;
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staffGroup",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      group_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      sort: {
        between: between(0, 999),
      },
      company_uuid: {
        required,
      },
      staffsUuids: {},
      levelsUuids: {},
      postsUuids: {},
    },
  },
};
</script>

<style scoped></style>
